package com.schoolconnect.app.feature.classes

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Popup
import androidx.compose.ui.window.PopupProperties
import androidx.compose.ui.platform.LocalDensity
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFieldRow
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogMultiSelectField
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogValidationSummary
import com.schoolconnect.app.designsystem.AppDialogSectionLabel
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSelectedBg
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListRowActionBar
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardItem
import com.schoolconnect.app.designsystem.list.AdminListSummaryCards
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminStatusChip
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.edit
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.info_circle
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.user
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.trash
import ischoolconnect.sharedui.generated.resources.users
import org.jetbrains.compose.resources.painterResource

internal val ClassesBackground = AppSecondaryBackground
internal val ClassesCard = AppSurface
internal val ClassesBorder = AppBorder
internal val ClassesLine = AppLine
internal val ClassesNavy = AppNavy
internal val ClassesMuted = AppMuted
internal val ClassesPrimary = AppPrimary
internal val ClassesPrimarySoft = AppPrimarySoft
internal val ClassesSuccess = AppSuccess
internal val ClassesSuccessBg = AppSuccessSoft
internal val ClassesDanger = AppDanger
internal val ClassesDangerBg = AppDangerSoft

private val ClassesDialogColors = com.schoolconnect.app.designsystem.AppDialogDefaultColors


internal fun classesTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    AdminListHeaderColumn("Class", 0.9f),
    AdminListHeaderColumn("Section", 0.7f),
    AdminListHeaderColumn("Subject Codes", 1.7f),
    AdminListHeaderColumn("Subject Count", 0.55f),
    AdminListHeaderColumn("Actions", 0.95f)
)

@Composable
internal fun RowScope.ClassesSummaryCardsShimmer() = AdminListSummaryCardsShimmer(
    cardCount = 3,
    cardHeight = 136.dp,
    cardShape = RoundedCornerShape(16.dp),
    contentPadding = PaddingValues(18.dp),
    iconSize = 56.dp,
    horizontalSpacing = 16.dp,
    titleWidth = 110.dp,
    titleHeight = 15.dp,
    valueWidth = 72.dp,
    valueHeight = 34.dp,
    subtitleWidth = 140.dp,
    subtitleHeight = 12.dp
)

@Composable
internal fun ClassesTableHeader(
    sortField: ClassesSortField,
    sortAscending: Boolean,
    onSortChanged: (ClassesSortField) -> Unit
) {
    AdminListSortHeaderRow(
        columns = listOf(
            AdminListSortColumn(
                label = "Class",
                weight = 0.9f,
                selected = sortField == ClassesSortField.CLASS_NAME,
                ascending = sortAscending,
                onClick = { onSortChanged(ClassesSortField.CLASS_NAME) }
            ),
            AdminListSortColumn(
                label = "Section",
                weight = 0.7f,
                selected = sortField == ClassesSortField.SECTION_NAME,
                ascending = sortAscending,
                onClick = { onSortChanged(ClassesSortField.SECTION_NAME) }
            ),
            AdminListSortColumn(
                label = "Subject Codes",
                weight = 1.7f,
                selected = sortField == ClassesSortField.SUBJECT_CODES,
                ascending = sortAscending,
                onClick = { onSortChanged(ClassesSortField.SUBJECT_CODES) }
            ),
            AdminListSortColumn(
                label = "Subject Count",
                weight = 0.55f,
                selected = sortField == ClassesSortField.SUBJECT_COUNT,
                ascending = sortAscending,
                onClick = { onSortChanged(ClassesSortField.SUBJECT_COUNT) }
            ),
        ),
        actionsLabel = "Actions",
        actionsWeight = 0.95f,
        actionsAlignment = Alignment.Center
    )
}

@Composable
internal fun ClassesTableBody(
    items: List<ClassSectionRowUi>,
    openActionMenuId: String?,
    onActionMenuToggle: (String) -> Unit,
    onActionMenuDismiss: (String) -> Unit,
    onViewDetails: (String) -> Unit,
    onEdit: (String) -> Unit,
    onDelete: (String) -> Unit
) {
    AdminListTableBody(items = items, key = { it.id }, modifier = Modifier.fillMaxWidth()) { item ->
        ClassesRow(
            item = item,
            isActionMenuOpen = openActionMenuId == item.id,
            onActionMenuToggle = { onActionMenuToggle(item.id) },
            onActionMenuDismiss = { onActionMenuDismiss(item.id) },
            onViewDetails = { onViewDetails(item.id) },
            onEdit = { onEdit(item.id) },
            onDelete = { onDelete(item.id) }
        )
    }
}

@Composable
internal fun ClassesRow(
    item: ClassSectionRowUi,
    isActionMenuOpen: Boolean,
    onActionMenuToggle: () -> Unit,
    onActionMenuDismiss: () -> Unit,
    onViewDetails: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        HorizontalDivider(color = ClassesLine.copy(alpha = 0.85f))
        Row(
            modifier = Modifier.fillMaxWidth().onViewDoubleClick(onViewDetails).height(52.dp).padding(horizontal = 24.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            AdminListTableBodyText(
                text = item.className,
                modifier = Modifier.weight(0.9f),
                color = ClassesNavy,
                fontWeight = FontWeight.SemiBold
            )
            AdminListTableBodyText(
                text = item.sectionName,
                modifier = Modifier.weight(0.7f),
                color = ClassesNavy,
                fontWeight = FontWeight.SemiBold
            )
            AdminListTableBodyText(
                text = item.subjectCodes.ifBlank { "-" },
                modifier = Modifier.weight(1.7f),
                color = ClassesNavy,
                fontWeight = FontWeight.Medium,
                maxLines = 1
            )
            AdminListTableBodyText(
                text = item.subjectCount.toString(),
                modifier = Modifier.weight(0.55f),
                color = ClassesNavy,
                fontWeight = FontWeight.Medium,
                maxLines = 1
            )
            Box(modifier = Modifier.weight(0.95f), contentAlignment = Alignment.Center) {
                AdminListRowActionBar(
                    isActive = item.status == ClassSectionStatusUi.ACTIVE,
                    expanded = isActionMenuOpen,
                    onExpandedChange = { onActionMenuToggle() },
                    onDismissRequest = onActionMenuDismiss,
                    onView = onViewDetails,
                    onEdit = onEdit,
                    onToggleStatus = null,
                    onDelete = onDelete,
                    width = 194.dp,
                    surfaceColor = ClassesCard,
                    borderColor = ClassesBorder
                )
            }
        }
    }
}

@Composable
internal fun ClassesTableEmptyState(modifier: Modifier = Modifier) {
    Column(
        modifier = modifier.padding(32.dp),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = "No classes found.",
            color = ClassesNavy,
            fontSize = 16.sp,
            fontWeight = FontWeight.SemiBold
        )
        Text(
            text = "Try adjusting filters or add a new class section.",
            color = ClassesMuted,
            fontSize = 13.sp
        )
    }
}

@Composable
internal fun ClassesFilterDialog(
    draft: ClassSectionFilterCriteria,
    classSectionValue: String,
    classSectionOptions: List<ClassSectionScopeOption>,
    isSaving: Boolean,
    onDismiss: () -> Unit,
    onReset: () -> Unit,
    onSave: (ClassSectionFilterCriteria) -> Unit,
    onClassSectionChanged: (String) -> Unit,
    onSubjectCodeChanged: (String) -> Unit,
    onCreatedFromChanged: (String) -> Unit,
    onCreatedToChanged: (String) -> Unit,
    subjectCodeOptions: List<String> = emptyList()
) {
    var classSectionExpanded by remember { mutableStateOf(false) }
    var subjectExpanded by remember { mutableStateOf(false) }
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        colors = ClassesDialogColors
    ) {
        AppDialogHeader(
            title = "Filter Classes",
            subtitle = "Refine classes by class, section, subject code or creation date.",
            onClose = onDismiss,
            colors = ClassesDialogColors,
            icon = Res.drawable.filter,
            iconContentDescription = "Filter classes"
        )
        AppDialogDivider(colors = ClassesDialogColors)
        AppDialogBody(
            colors = ClassesDialogColors,
            horizontalPadding = 24.dp,
            compactHorizontalPadding = 20.dp,
            verticalPadding = 20.dp
        ) { compact ->
            Column(verticalArrangement = Arrangement.spacedBy(if (compact) 18.dp else 28.dp)) {
                AppDialogFieldRow(spacing = 28.dp) {
                    AppDialogFieldColumn(modifier = Modifier.weight(1f), label = "Class / Section", colors = ClassesDialogColors) {
                        AppDialogSelectField(
                            value = classSectionValue,
                            placeholder = ALL_CLASS_SECTIONS_LABEL,
                            expanded = classSectionExpanded,
                            options = classSectionOptions.map { it.label },
                            onToggleExpanded = { classSectionExpanded = !classSectionExpanded },
                            onDismissExpanded = { classSectionExpanded = false },
                            onSelected = { classSectionExpanded = false; onClassSectionChanged(it) },
                            colors = ClassesDialogColors
                        )
                    }
                }
                AppDialogFieldRow(spacing = 28.dp) {
                    AppDialogFieldColumn(modifier = Modifier.weight(1f), label = "Subject Code", colors = ClassesDialogColors) {
                        AppDialogSelectField(
                            value = draft.subjectCode,
                            placeholder = "Select Subject Code",
                            expanded = subjectExpanded,
                            options = subjectCodeOptions,
                            onToggleExpanded = { subjectExpanded = !subjectExpanded },
                            onDismissExpanded = { subjectExpanded = false },
                            onSelected = { subjectExpanded = false; onSubjectCodeChanged(it) },
                            colors = ClassesDialogColors
                        )
                    }
                }
                AppDialogFieldRow(spacing = 28.dp) {
                    AppDialogFieldColumn(modifier = Modifier.weight(1f), label = "Created Date From", colors = ClassesDialogColors) {
                        AppDialogDateField(
                            value = draft.createdFrom,
                            onValueChange = onCreatedFromChanged,
                            placeholder = "DD MMM YYYY",
                            colors = ClassesDialogColors
                        )
                    }
                    AppDialogFieldColumn(modifier = Modifier.weight(1f), label = "Created Date To", colors = ClassesDialogColors) {
                        AppDialogDateField(
                            value = draft.createdTo,
                            onValueChange = onCreatedToChanged,
                            placeholder = "DD MMM YYYY",
                            colors = ClassesDialogColors
                        )
                    }
                }
            }
        }
        AppDialogDivider(colors = ClassesDialogColors)
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction(
                    label = "Reset",
                    onClick = onReset,
                    enabled = !isSaving,
                    style = AppDialogActionStyle.Secondary,
                    width = 208.dp
                ),
                AppDialogFooterAction(
                    label = "Cancel",
                    onClick = onDismiss,
                    enabled = !isSaving,
                    style = AppDialogActionStyle.Secondary,
                    width = 216.dp
                ),
                AppDialogFooterAction(
                    label = "Apply",
                    onClick = {
                        onSave(draft)
                        onDismiss()
                    },
                    enabled = !isSaving,
                    style = AppDialogActionStyle.Primary,
                    width = 264.dp
                )
            ),
            colors = ClassesDialogColors,
            horizontalArrangement = Arrangement.End
        )
    }
}

@Composable
internal fun ClassesEditorDialog(
    draft: ClassSectionEditorDraft,
    availableSubjectOptions: List<Pair<String, String>>,
    isSaving: Boolean,
    apiError: String = "",
    onDismiss: () -> Unit,
    onSave: () -> Unit,
    onClassChanged: (String) -> Unit,
    onSectionChanged: (String) -> Unit,
    onSubjectCodesChanged: (List<String>) -> Unit
) {
    var hasSubmitted by remember(draft.id) { mutableStateOf(draft.id.isNotBlank()) }
    var subjectCodesExpanded by remember(draft.id) { mutableStateOf(false) }
    val validation = remember(hasSubmitted, draft.className, draft.sectionName, draft.subjectCodes) {
        if (hasSubmitted) validateClassSectionEditor(draft) else ClassSectionEditorValidationErrors()
    }
    AppDialogScaffold(
        onDismiss = { if (!isSaving) onDismiss() },
        dismissOnClickOutside = false,
        size = AppDialogSize.Standard,
        colors = ClassesDialogColors,
        isLoading = isSaving,
        loadingTitle = if (draft.id.isBlank()) "Adding class" else "Saving class"
    ) {
        AppDialogHeader(
            title = if (draft.id.isBlank()) "Add Class" else "Edit Class",
            subtitle = "Create or update a class and section mapping.",
            onClose = { if (!isSaving) onDismiss() },
            colors = ClassesDialogColors
        )
        AppDialogValidationSummary(
            errors = listOf(validation.className, validation.sectionName, validation.subjectCodes),
            colors = ClassesDialogColors,
            modifier = Modifier.padding(horizontal = 24.dp, vertical = 12.dp)
        )
        AppDialogErrorMessage(
            message = apiError,
            colors = ClassesDialogColors,
            modifier = Modifier.padding(horizontal = 24.dp, vertical = 12.dp)
        )
        AppDialogDivider(colors = ClassesDialogColors)
        AppDialogBody(
            colors = ClassesDialogColors,
            horizontalPadding = 24.dp,
            compactHorizontalPadding = 20.dp,
            verticalPadding = 20.dp
        ) { compact ->
            Column(verticalArrangement = Arrangement.spacedBy(if (compact) 12.dp else 16.dp)) {
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    AppDialogFieldColumn(
                        label = "Class",
                        modifier = Modifier.weight(1f),
                        required = true,
                        error = validation.className,
                        colors = ClassesDialogColors
                    ) {
                        AppDialogTextField(
                            value = draft.className,
                            onValueChange = onClassChanged,
                            placeholder = "Enter class",
                            error = validation.className,
                            colors = ClassesDialogColors
                        )
                    }
                    AppDialogFieldColumn(
                        label = "Section",
                        modifier = Modifier.weight(1f),
                        required = true,
                        error = validation.sectionName,
                        colors = ClassesDialogColors
                    ) {
                        AppDialogTextField(
                            value = draft.sectionName,
                            onValueChange = onSectionChanged,
                            placeholder = "Enter section",
                            error = validation.sectionName,
                            colors = ClassesDialogColors
                        )
                    }
                }
                AppDialogFieldColumn(
                    label = "Subject Codes",
                    required = true,
                    error = validation.subjectCodes,
                    colors = ClassesDialogColors
                ) {
                    AppDialogMultiSelectField(
                        selectedValues = draft.subjectCodes,
                        placeholder = "Select subject codes",
                        options = availableSubjectOptions.map { it.first },
                        expanded = subjectCodesExpanded,
                        onToggleExpanded = { subjectCodesExpanded = !subjectCodesExpanded },
                        onDismissExpanded = { subjectCodesExpanded = false },
                        onSelectionChanged = onSubjectCodesChanged,
                        colors = ClassesDialogColors,
                        error = validation.subjectCodes,
                        optionLabels = availableSubjectOptions.associate { (code, label) ->
                            code to "$code - ${label.ifBlank { code }}"
                        },
                        searchPlaceholder = "Search subjects",
                        emptyResultsText = "No subjects found"
                    )
                }
            }
        }
        AppDialogDivider(colors = ClassesDialogColors)
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction(
                    label = "Cancel",
                    onClick = { if (!isSaving) onDismiss() },
                    enabled = !isSaving,
                    style = AppDialogActionStyle.Secondary
                ),
                AppDialogFooterAction(
                    label = when {
                        isSaving && draft.id.isBlank() -> "Adding..."
                        isSaving -> "Saving..."
                        draft.id.isBlank() -> "Add"
                        else -> "Save"
                    },
                    onClick = {
                        if (!isSaving) {
                            hasSubmitted = true
                            if (!validateClassSectionEditor(draft).hasAnyError) onSave()
                        }
                    },
                    enabled = !isSaving,
                    style = AppDialogActionStyle.Primary
                )
            ),
            colors = ClassesDialogColors,
            equalWeightButtons = true
        )
    }
}

@Composable
internal fun ClassesDetailsDialog(
    row: ClassSectionRowUi,
    subjectCodeReference: List<Pair<String, String>>,
    onClose: () -> Unit
) {
    var referenceExpanded by remember { mutableStateOf(false) }
    var referenceAnchorSize by remember { mutableStateOf(IntSize.Zero) }
    val density = LocalDensity.current
    val referenceOffset = with(density) {
        IntOffset(0, referenceAnchorSize.height + 8.dp.roundToPx())
    }
    val createdAt = row.createdAt.ifBlank { "-" }
    val updatedAt = row.updatedAt.ifBlank { "-" }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Standard,
        colors = ClassesDialogColors
    ) {
        AppDialogHeader(
            title = "View Class",
            subtitle = "Class section details",
            onClose = onClose,
            colors = ClassesDialogColors
        )
        AppDialogDivider(colors = ClassesDialogColors)
        AppDialogBody(
            colors = ClassesDialogColors,
            horizontalPadding = 28.dp,
            compactHorizontalPadding = 20.dp,
            verticalPadding = 16.dp
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(10.dp),
                    colors = CardDefaults.cardColors(containerColor = ClassesCard),
                    border = BorderStroke(1.dp, ClassesBorder)
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = 16.dp, vertical = 14.dp),
                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        detailStat(
                            modifier = Modifier.weight(1f),
                            icon = painterResource(Res.drawable.user),
                            label = "Created By",
                            value = row.createdBy.ifBlank { "-" }
                        )
                        detailStat(
                            modifier = Modifier.weight(1f),
                            icon = painterResource(Res.drawable.user),
                            label = "Updated By",
                            value = row.updatedBy.ifBlank { "-" }
                        )
                        detailStat(
                            modifier = Modifier.weight(1f),
                            icon = painterResource(Res.drawable.calendar),
                            label = "Created Date",
                            value = createdAt
                        )
                        detailStat(
                            modifier = Modifier.weight(1f),
                            icon = painterResource(Res.drawable.calendar),
                            label = "Last Updated",
                            value = updatedAt
                        )
                    }
                }

                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(10.dp),
                    colors = CardDefaults.cardColors(containerColor = ClassesCard),
                    border = BorderStroke(1.dp, ClassesBorder)
                ) {
                    Column(
                        modifier = Modifier.padding(horizontal = 16.dp, vertical = 14.dp),
                        verticalArrangement = Arrangement.spacedBy(14.dp)
                    ) {
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(12.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(
                                painter = painterResource(Res.drawable.info_circle),
                                contentDescription = null,
                                tint = ClassesPrimary,
                                modifier = Modifier.size(19.dp)
                            )
                            Text(
                                text = "Class Information",
                                color = ClassesPrimary,
                                fontSize = 17.sp,
                                fontWeight = FontWeight.ExtraBold
                            )
                        }
                        HorizontalDivider(color = ClassesBorder)
                        detailInfoRow("Class", row.className)
                        detailInfoRow("Section", row.sectionName)
                        detailInfoRow(
                            label = "Subject Codes",
                            value = row.subjectCodes.ifBlank { "-" },
                            trailing = {
                                Box {
                                    Icon(
                                        painter = painterResource(Res.drawable.info_circle),
                                        contentDescription = "Subject Code Reference",
                                        tint = ClassesPrimary,
                                        modifier = Modifier
                                            .size(22.dp)
                                            .onSizeChanged { referenceAnchorSize = it }
                                            .clickable { referenceExpanded = !referenceExpanded }
                                    )

                                    if (referenceExpanded) {
                                        Popup(
                                            alignment = Alignment.TopStart,
                                            offset = referenceOffset,
                                            onDismissRequest = { referenceExpanded = false },
                                            properties = PopupProperties(
                                                focusable = true,
                                                dismissOnBackPress = true,
                                                dismissOnClickOutside = true
                                            )
                                        ) {
                                            Surface(
                                                modifier = Modifier
                                                    .width(390.dp)
                                                    .heightIn(max = 360.dp)
                                                    .border(1.dp, ClassesBorder, RoundedCornerShape(10.dp)),
                                                shape = RoundedCornerShape(10.dp),
                                                color = Color.White
                                            ) {
                                                Column(
                                                    modifier = Modifier.padding(16.dp),
                                                    verticalArrangement = Arrangement.spacedBy(12.dp)
                                                ) {
                                                    Text(
                                                        text = "All Subjects",
                                                        color = ClassesNavy,
                                                        fontSize = 16.sp,
                                                        fontWeight = FontWeight.ExtraBold
                                                    )
                                                    Row(
                                                        modifier = Modifier.fillMaxWidth(),
                                                        horizontalArrangement = Arrangement.SpaceBetween
                                                    ) {
                                                        Text("Subject", color = ClassesMuted, fontSize = 12.sp, fontWeight = FontWeight.Bold)
                                                        Text("Code", color = ClassesMuted, fontSize = 12.sp, fontWeight = FontWeight.Bold)
                                                    }
                                                    HorizontalDivider(color = ClassesBorder)
                                                    if (subjectCodeReference.isEmpty()) {
                                                        Text("No subject records available.", color = ClassesMuted, fontSize = 13.sp)
                                                    } else {
                                                        LazyColumn(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                                            items(subjectCodeReference, key = { it.first }) { (code, name) ->
                                                                Row(
                                                                    modifier = Modifier.fillMaxWidth(),
                                                                    horizontalArrangement = Arrangement.SpaceBetween,
                                                                    verticalAlignment = Alignment.CenterVertically
                                                                ) {
                                                                    Text(name, color = ClassesNavy, fontSize = 13.sp, fontWeight = FontWeight.Medium)
                                                                    Text(code, color = ClassesPrimary, fontSize = 13.sp, fontWeight = FontWeight.Bold)
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        )
                        detailInfoRow(
                            label = "Status",
                            value = row.status.label,
                            valueColor = classesStatusColor(row.status)
                        )
                    }
                }
            }
        }
        AppDialogDivider(colors = ClassesDialogColors)
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction(
                    label = "Close",
                    onClick = onClose,
                    style = AppDialogActionStyle.Secondary
                )
            ),
            colors = ClassesDialogColors
        )
    }
}

@Composable
private fun detailStat(
    modifier: Modifier = Modifier,
    icon: Painter,
    label: String,
    value: String
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(38.dp)
                .background(Color(0xFFEAF1FF), RoundedCornerShape(19.dp)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = icon,
                contentDescription = null,
                tint = ClassesPrimary,
                modifier = Modifier.size(18.dp)
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(3.dp)) {
            Text(
                text = label,
                color = ClassesMuted,
                fontSize = 12.sp,
                fontWeight = FontWeight.Medium
            )
            Text(
                text = value,
                color = ClassesNavy,
                fontSize = 14.sp,
                fontWeight = FontWeight.ExtraBold
            )
        }
    }
}

@Composable
private fun detailInfoRow(
    label: String,
    value: String,
    valueColor: Color = ClassesNavy,
    trailing: (@Composable () -> Unit)? = null
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(14.dp)
    ) {
        Text(
            text = label,
            modifier = Modifier.width(128.dp),
            color = ClassesNavy,
            fontSize = 14.sp,
            fontWeight = FontWeight.ExtraBold
        )
        Text(
            text = ":",
            color = ClassesMuted,
            fontSize = 14.sp,
            fontWeight = FontWeight.ExtraBold
        )
        Text(
            text = value,
            modifier = Modifier.weight(1f),
            color = valueColor,
            fontSize = 14.sp,
            fontWeight = FontWeight.SemiBold
        )
        trailing?.invoke()
    }
}

@Composable
private fun detailRow(label: String, value: String) {
    Row(horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
        Text(
            text = "$label:",
            color = ClassesMuted,
            fontSize = 13.sp,
            fontWeight = FontWeight.SemiBold
        )
        Text(
            text = value,
            color = ClassesNavy,
            fontSize = 14.sp,
            fontWeight = FontWeight.Medium
        )
    }
}

private fun classesStatusColor(status: ClassSectionStatusUi): Color = when (status) {
    ClassSectionStatusUi.ACTIVE -> ClassesSuccess
    ClassSectionStatusUi.INACTIVE -> ClassesDanger
}

private fun classesStatusBackground(status: ClassSectionStatusUi): Color = when (status) {
    ClassSectionStatusUi.ACTIVE -> ClassesSuccessBg
    ClassSectionStatusUi.INACTIVE -> ClassesDangerBg
}

private fun classesActionIcon(status: ClassSectionStatusUi) =
    if (status == ClassSectionStatusUi.ACTIVE) Res.drawable.ban else Res.drawable.circle_check
